import React, { useEffect, useState, useMemo, useContext } from "react";
import { Container, Col, Row, Accordion, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import "./AllEquitiesFilter.css";
// import "../Products/AllEquitiesFilter.css";
import "../../AllEquities/Pagination/pagination.css";
import "../../AllEquities/AllEquitiesFilter/AllEquitiesFilter.css"
import Pagination from "../../AllEquities/Pagination/Pagination";
import URLstateContext from "../../../provider/CommonContext";

let PageSize = 8;
let allAMC = [];
let allCategory = [];
let allRisk = [];
// var objFilters = { 'AMC': [], 'category': [], 'Risk': [], 'FundSize': [], 'Invest_Type': [] };
var objFilters = { 'AMC': [], 'category': [], 'Risk': [], 'FundSize': [], 'Invest_Type': [] };
let c_allcompdata = null;
let compdata = null;
let setdetails = null;
var arr = [];
var t_setSchemesdata = null;
function AllMutualFundsFilters() {
    const { BaseURL } = useContext(URLstateContext);
    const [checkedAMC, setAMC] = useState([]);
    const [checkedCategory, setCategory] = useState([]);
    const [checkedRisk, setRisk] = useState([]);
    const [checkedSchemes, setSchemesdata] = useState([]);
    const [isLoaded, setisLoaded] = useState(false);
    const [checked, setChecked] = useState([]);
    const [is_hide_chk, set_is_hide_chk] = useState("");
    const allAMCcode = [];
    const allCategoryCode = [];
    const allRiskCode = [];
    let navigate = useNavigate();

    //pagination starts
    const [currentPage, setCurrentPage] = useState(1);
    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        if (checkedSchemes.length > 0) {
            return checkedSchemes.slice(firstPageIndex, lastPageIndex);
        }

    }, [currentPage, checkedSchemes]);
    //pagination ends


    useEffect(() => {
        //page load
        // getallparameters();
        var parametrs = {
            mf_cocode: '-',
            category: '-',
            subcategory: '-',
            riskometer: '-',
            aumsize: '-',
            investmenttype: '-',
        }
        getdata(parametrs)
    }, []);

    //Bind AMC list data starts
    useEffect(() => {
        const getAMCListUrl = BaseURL + "AMC-List";
        fetch(`${getAMCListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                setAMC(myrepo);
                // console.log("myrepomyrepo : " + JSON.stringify(myrepo));
            })
            .catch((error) => {
                //console.log("not found the api");
            });

    }, []);

    function getdata(parametrs) {
        const getSchemePerformanceUrl = BaseURL + "SchemePerformance";
        fetch(`${getSchemePerformanceUrl}/${parametrs.mf_cocode}/${parametrs.category}/${parametrs.subcategory}/${parametrs.riskometer}/${parametrs.aumsize}/${parametrs.investmenttype}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                c_allcompdata = JSON.stringify(myrepo);
                setSchemesdata(myrepo);
                t_setSchemesdata = myrepo
                setisLoaded(true);
            })
            .catch((error) => {
               // console.log("not found the api");
            });
    }
    const handleCheck = (event, param) => {
       if (event.target.checked == true && param['type'] == "AMC") {
            objFilters[param['type']].push(param['Value'])
        } else if (event.target.checked == false && param['type'] == "AMC") {
            for (var i = 0; i < objFilters['AMC'].length; i++) {
                objFilters['AMC'].splice(i, 1);
                break;
            }
        }
        else if (event.target.checked == true && param['type'] == "category") {
            objFilters[param['type']].push(param['Value'])
        } else if (event.target.checked == false && param['type'] == "category") {
            for (var i = 0; i < objFilters['category'].length; i++) {
                objFilters['category'].splice(i, 1);
                break;
            }
        }
        else if (event.target.checked == true && param['type'] == "Risk") {
            objFilters[param['type']].push(param['Value'])

            // allRisk.push(param['Value']);
        } else if (event.target.checked == false && param['type'] == "Risk") {
            for (var i = 0; i < objFilters['Risk'].length; i++) {
                objFilters['Risk'].splice(i, 1);
                break;
            }
        }
        else if (param['type'] == "FundSize") {
            if (objFilters['FundSize'].length <= 0) { objFilters[param['type']].push(param['Value']) } else {
                for (var i = 0; i < objFilters['FundSize'].length; i++) {
                    objFilters['FundSize'].splice(i, 1);
                    break;
                }
                objFilters[param['type']].push(param['Value'])
            }

        }
        else if (event.target.checked == true && param['type'] == "Invest_Type") {
            objFilters[param['type']].push(param['Value'])
        }
        else if (event.target.checked == false && param['type'] == "Invest_Type") {
            for (var i = 0; i < objFilters['Invest_Type'].length; i++) {
                objFilters['Invest_Type'].splice(i, 1);
                break;
            }
        }
        else if (objFilters['AMC'] == null && objFilters['category'] == null && objFilters['Risk'] == null && objFilters['FundSize'] == null && objFilters['Invest_Type'] == null) {

            // setSchemesdata(t_setSchemesdata);
        }
        const filtered2 = t_setSchemesdata.filter(obj => {
            if (objFilters['AMC'].length == 0 ? true : objFilters['AMC'].includes(obj.mf_cocode) &&
                objFilters['category'].length == 0 ? true : objFilters['category'].includes(obj.maincategory)) {
               // console.log("asdfadasd")
            }

            //console.log("Cond:")
            console.log(objFilters['AMC'].length == 0 ? true : objFilters['AMC'].includes(obj.mf_cocode) &&
                objFilters['category'].length == 0 ? true : objFilters['category'].includes(obj.maincategory))

            return (objFilters['AMC'].length == 0 ? true : objFilters['AMC'].includes(obj.mf_cocode)) &&
                (objFilters['category'].length == 0 ? true : objFilters['category'].includes(obj.maincategory)) &&
                (objFilters['Risk'].length == 0 ? true : objFilters['Risk'].includes(obj.riskometervalue)) &&
                (objFilters['FundSize'].length == 0 ? true : objFilters['FundSize'] >= (obj.aum)) &&
                (objFilters['Invest_Type'].length == 0 ? true : objFilters['Invest_Type'].includes(obj.investmenttype))

        });
        setSchemesdata(filtered2)
    };
    useEffect(() => {
        const getmaincategoryListUrl = BaseURL + "CategoryMaster/main-category";
        fetch(`${getmaincategoryListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                setCategory(myrepo);
              //  console.log("setCategorymyrepo : " + JSON.stringify(myrepo));
            })
            .catch((error) => {
              //  console.log("not found the api");
            });

    }, []);
    useEffect(() => {
        const getRiskListUrl = BaseURL + "RiskometerList";
        fetch(`${getRiskListUrl}`)
            .then((response) => response.json())
            .then((data) => {
                const myrepo = data.data;
                setRisk(myrepo);
            })
            .catch((error) => {
              //  console.log("not found the api");
            });

    }, []);


    function send_me_data(){
        try{
        return isLoaded ? (
            currentTableData.length > 0 ?   (  
                currentTableData.map((getallcompdata, indexalldata) => {
                    return (
                        <div className="body-row" key={indexalldata}>
                            <p className="text-left" >{getallcompdata.schemename}</p>
                            <p className="text-right" >{getallcompdata.year1_ret.toFixed(2)}%
                                <span className="color-red" >1Y</span>
                            </p>
                            <p className="text-right" >{getallcompdata.year3_ret.toFixed(2)}%
                                <span className="color-red" >3Y</span>
                            </p>
                            <p className="text-right" >{getallcompdata.year5_ret.toFixed(2)}%
                                <span className="color-red" >5Y</span>
                            </p>

                        </div>
                    );
                })) : (<div>No Data..</div> 
            )) : (<div>No Data Available..</div>)
        }
        catch(err){
            return (<div>No Data Available..</div>)
        }
    }
    return (
        <>
            <section className="filter-equities">
                <Container>
                    <Row>
                        <Col md={4}>
                            <div className="filter-block">
                                <div>
                                    <h4>
                                        <span>Filters</span>
                                        <span>Clear All</span>
                                    </h4>
                                </div>
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>AMC</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Type to search"
                                                    id="search_sectorlist"
                                                // onChange={value_handler}
                                                // value={q}
                                                />
                                            </Form.Group>

                                            {/* tejaswini code for checkbox bind starts */}
                                            <Form.Group className="mb-3" id="select_sectorlistcontainer" style={{ "max-height": "150px", "overflow-y": "scroll" }}>

                                                {checkedAMC.map((item, index) => (
                                                    <div key={index}>
                                                        <input value={item.mf_cocode} type="checkbox" onChange={event => handleCheck(event, { "type": "AMC", "Value": item.mf_cocode })} style={{ "margin-left": "10px", "margin-right": "10px" }} />
                                                        <span className={is_hide_chk}>{item.lname}</span>
                                                    </div>
                                                ))}
                                            </Form.Group>

                                        </Accordion.Body>

                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Category</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group className="mb-3" id="select_sectorlistcontainer" style={{ "max-height": "150px", "overflow-y": "scroll" }}>

                                                {checkedCategory.map((item, index) => (
                                                    <div key={index}>
                                                        <input value={item.category} type="checkbox" onChange={event => handleCheck(event, { "type": "category", "Value": item.categorycode })} style={{ "margin-left": "10px", "margin-right": "10px" }} />
                                                        <span className={is_hide_chk}>{item.category}</span>
                                                    </div>
                                                ))}
                                            </Form.Group>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Risk</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group className="mb-3" id="select_sectorlistcontainer" style={{ "max-height": "150px", "overflow-y": "scroll" }}>

                                                {checkedRisk.map((item, index) => (
                                                    <div key={index}>
                                                        <input value={item.riskometervalue} type="checkbox" onChange={event => handleCheck(event, { "type": "Risk", "Value": item.riskometervalue })} style={{ "margin-left": "10px", "margin-right": "10px" }} />
                                                        <span className={is_hide_chk}>{item.riskometervalue}</span>
                                                    </div>
                                                ))}
                                            </Form.Group>
                                        </Accordion.Body>
                                    </Accordion.Item>


                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>Fund Size</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                {/* <Form.Check type="radio" name="Upto 1,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 1000 })} /> */}
                                                <input type="radio" value="1000" name="Upto 1,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 1000 })} /> Upto 1,000Cr
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                {/* <Form.Check type="checkbox" label="Upto 2,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 2000 })} /> */}
                                                <input type="radio" value="2000" name="Upto 2,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 2000 })} /> Upto 2,000Cr
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                {/* <Form.Check type="checkbox" label="Upto 3,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 3000 })} /> */}
                                                <input type="radio" value="3000" name="Upto 3,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 3000 })} /> Upto 3,000Cr


                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                {/* <Form.Check type="checkbox" label="Upto 5,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": '5000' })} /> */}
                                                <input type="radio" value="50000" name="Upto 5,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 50000 })} /> Upto 5,000Cr
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                {/* <Form.Check type="checkbox" label="Upto 10,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": '10000' })} /> */}
                                                <input type="radio" value="10000" name="Upto 10,000Cr" onChange={event => handleCheck(event, { "type": "FundSize", "Value": 10000 })} /> Upto 10,000Cr
                                            </Form.Group>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>Available To Invest</Accordion.Header>
                                        <Accordion.Body>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                <Form.Check type="checkbox" label="SIP" onChange={event => handleCheck(event, { "type": "Invest_Type", "Value": "SIP" })} />
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId="formBasicCheckbox"
                                            >
                                                <Form.Check type="checkbox" label="ONE-TIME" onChange={event => handleCheck(event, { "type": "Invest_Type", "Value": "one-time" })} />
                                            </Form.Group>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className="products-card">
                                <h5>2500 Equities</h5>
                                <div className="product-table">
                                   
                                    {
                                        send_me_data()
                                    }
                                </div>
                                {isLoaded ? (
                                    <Pagination
                                        className="pagination-bar"
                                        currentPage={currentPage}
                                        totalCount={checkedSchemes.length}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    />
                                ) : (
                                    <div>Nothing to display</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default AllMutualFundsFilters;
